module.exports = __webpack_public_path__ + "img/crc-07.36dbda5f.jpg";